import FetchClient, { type ApiResponse } from "./FetchClient";
import type { ProductListItem } from "../types/Product";

export type GlobalSearchSort = "relevance" | "discount" | "priceAsc";

export interface GlobalSearchParams {
  q: string;
  /** API retailer id (PublicDealsRetailer.apiRetailer); empty searches every store. */
  retailer?: string;
  sort?: GlobalSearchSort;
  limit?: number;
  offset?: number;
}

export interface GlobalSearchProduct extends ProductListItem {
  retailer: string;
}

export interface GlobalSearchResult {
  query: string;
  products: GlobalSearchProduct[];
  total: number;
  /** Matches per store across the whole query (ignores the retailer filter). */
  retailers: Array<{ retailer: string; count: number }>;
  hasMore: boolean;
  /** False while the server builds its index after a restart. */
  ready: boolean;
}

/** Search every public online deal feed at once (GET /public/search). */
export async function searchOnlineDeals(params: GlobalSearchParams): Promise<GlobalSearchResult> {
  const query = new URLSearchParams({ q: params.q.trim() });
  if (params.retailer) query.set("retailer", params.retailer);
  if (params.sort && params.sort !== "relevance") query.set("sort", params.sort);
  if (params.limit) query.set("limit", String(params.limit));
  if (params.offset) query.set("offset", String(params.offset));
  const response = await FetchClient.get<ApiResponse<GlobalSearchResult>>(`/public/search?${query.toString()}`, {}, "optional");
  const data = response.data;
  return {
    query: data?.query ?? params.q,
    products: (data?.products ?? []).map((product) => ({ ...product, upc: "", sku: "", storeId: "online" })),
    total: data?.total ?? 0,
    retailers: data?.retailers ?? [],
    hasMore: Boolean(data?.hasMore),
    ready: data?.ready !== false,
  };
}
